export const COURSE_TYPE = {
  ONLINE: 'online',
  OFFLINE: 'offline'
}